<template>
  <el-card id="UserDeal">
    <template #header>
      <h4>{{ $t('我的交易') }}</h4>
    </template>

    <el-form :model="searchForm" inline size="small">
      <el-form-item :label="$t('订单号')">
        <el-input :placeholder="$t('订单号')" v-model="searchForm.num" clearable />
      </el-form-item>

      <el-form-item :label="$t('菜谱编号')">
        <el-input :placeholder="$t('菜谱编号')" v-model="searchForm.cookbookNum" clearable />
      </el-form-item>
      <el-form-item :label="$t('订单内容')">
        <dict-select clearable v-model="searchForm.orderType" flag="ORDER_TYPE" />
      </el-form-item>
      <el-form-item :label="$t('类型')">
        <dict-select clearable v-model="searchForm.type" flag="DEAL_TYPE" />
      </el-form-item>

      <el-form-item :label="$t('交易状态')">
        <dict-select clearable v-model="searchForm.status" flag="ORDER_STATUS" />
      </el-form-item>

      <el-form-item :label="$t('交易方式')">
        <dict-select clearable v-model="searchForm.payType" flag="PAY_TYPE" />
      </el-form-item>

      <el-form-item :label="$t('交易时间')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>

    </el-form>

    <table-list
        ref="list"
        :search-params="searchForm"
        :request-params="{bothUserNum: $route.query.num}"
        @query="handleLoadList"
        :auto="false"
        :data="tableData"
        :backTop="false"
        :page-sizes="[5, 10]">
      <el-table-column type="selection" width="50" />
      <el-table-column align="center" prop="num" :label="$t('订单号')" />
      <el-table-column :label="$t('用户编号')" prop="userNum" />
      <el-table-column :label="$t('用户昵称')" prop="username" />
      <el-table-column align="center" prop="cookbookNum" :label="$t('菜谱编号')" />
      <el-table-column align="center" :label="$t('菜谱缩略图')">
        <template v-slot="{row}">
          <preview-img :size="40" :img-url="row.cookbookCover" />
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('订单内容')">
        <template v-slot="{row}">
          <dict-text :status="row.orderType" dict-flag="ORDER_TYPE" />
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('交易方式')">
        <template v-slot="{row}">
          <dict-text :status="row.payType" dict-flag="PAY_TYPE" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="price" :label="$t('金额')" />
      <el-table-column align="center" prop="name" :label="$t('类型')">
        <template v-slot="{row}">
          <dict-text :status="row.type" dict-flag="DEAL_TYPE" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" :label="$t('交易状态')">
        <template v-slot="{row}">
          <dict-text :status="row.status" dict-flag="ORDER_STATUS" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" :label="$t('交易时间')">
        <template v-slot="{row}">
          {{row.createTime | formatDate}}
        </template>
      </el-table-column>
    </table-list>
  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DictText from "@/components/dict/DictText.vue";
import DictSelect from "@/components/dict/DictSelect.vue";
export default {
  name: "UserDeal",
  components: {DictSelect, DictText, PreviewImg, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.anOrder.listMy, params);
        this.tableData = res.anOrders.map(item => {
          // 判断类型，如果两个userNum 不相等需要反转
          const {userNum, receiveUserNum} = item;
          if(receiveUserNum && userNum !== receiveUserNum) {
            item.type = item.type === "out" ? "in" : "out";
          }
          return item;
        })
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  mounted() {
    // 监听组件是否出现在视口
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        console.log('组件出现在视口 UserDeal');
        this.$refs.list.handleRequest();
        this.observer.unobserve(document.getElementById("UserDeal"));
      }
    })

    this.observer.observe(document.getElementById("UserDeal"));
    this.$once('hook:beforeDestroy', () => {
      this.observer.disconnect();
    })
  },
}
</script>

<style scoped>

</style>
